module.exports = __webpack_public_path__ + "media/images/thum-d6db0825347fa7ccb79db2fd026c9931.jpg";